var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.386 6.97545L35.3846 5L51.3832 6.97545L63.7691 26.395L35.3846 64.9998L7 26.395L19.386 6.97545Z",
    fill: "#FDB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4971 26.3936L35.3844 64.9986L7 26.3936H18.4971ZM52.2723 26.3936L35.3844 64.9986L63.7693 26.3936",
    fill: "#EA6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4961 26.3936H52.2708L35.3835 64.9986",
    fill: "#FDAD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3835 5L19.3849 6.9751L18.4961 26.3948L35.3835 5ZM35.3835 5L51.3823 6.9751L52.2712 26.3948",
    fill: "#FDD231"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7693 26.3952L51.3834 6.97559L52.2723 26.3952H63.7693ZM7 26.3952L19.3859 6.97559L18.4971 26.3952",
    fill: "#FDAD00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3835 5L18.4961 26.3948H52.2708",
    fill: "#FEEEB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.1d3c62755a3a915ec5b6f929c8a5b852.svg";
export { ForwardRef as ReactComponent };